// components/PrivacyPolicy.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles/legalPage.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">&larr; Back to Home</Link>
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-updated">Last Updated: March 11, 2026</p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            Mangold, Inc. ("Company," "we," "us," or "our") is committed to protecting your privacy.
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information
            when you visit our website mangold.ai, use our services, or engage with us for digital
            marketing, web development, and related project management services.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Information We Collect</h2>
          <h3>2.1 Information You Provide</h3>
          <ul>
            <li>Contact information (name, email address, company name)</li>
            <li>Project details and business requirements shared during consultations</li>
            <li>Communication records (emails, messages, meeting notes)</li>
            <li>Billing and payment information for contracted services</li>
            <li>Account credentials for third-party platforms we manage on your behalf</li>
          </ul>
          <h3>2.2 Information Collected Automatically</h3>
          <ul>
            <li>Device and browser information</li>
            <li>IP address and approximate location</li>
            <li>Website usage data and analytics</li>
            <li>Cookies and similar tracking technologies</li>
          </ul>
          <h3>2.3 Client Project Data</h3>
          <p>
            In the course of providing digital marketing, SEO, app store optimization, and development
            services, we may access and process data from your advertising accounts, analytics platforms,
            and other third-party services as authorized by you.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To provide, maintain, and improve our services</li>
            <li>To manage client projects including digital marketing campaigns, SEO, and app promotion</li>
            <li>To communicate with you about projects, updates, and service-related matters</li>
            <li>To process payments and manage billing</li>
            <li>To analyze website performance and optimize user experience</li>
            <li>To comply with legal obligations</li>
            <li>To generate anonymized, aggregated performance reports</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Data Sharing and Disclosure</h2>
          <p>We do not sell your personal information. We may share your data with:</p>
          <ul>
            <li><strong>Service Providers:</strong> Third-party tools and platforms necessary for project execution (e.g., advertising platforms, analytics tools, hosting providers)</li>
            <li><strong>Legal Requirements:</strong> When required by law, regulation, or legal process</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
            <li><strong>With Your Consent:</strong> When you have given explicit permission</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. Client Data and Advertising Accounts</h2>
          <p>
            When managing client advertising accounts, analytics, or marketing campaigns, we act as a
            data processor on your behalf. We access only the data necessary to perform contracted
            services and follow your instructions regarding data handling. Upon termination of services,
            we will return or delete client data as requested.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your information,
            including encryption, access controls, and secure data storage. However, no method of
            electronic transmission or storage is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Data Retention</h2>
          <p>
            We retain personal information for as long as necessary to fulfill the purposes described
            in this policy, comply with legal obligations, resolve disputes, and enforce our agreements.
            Project data is retained for the duration of the engagement plus a reasonable period
            thereafter, unless otherwise agreed.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your personal information</li>
            <li>Object to or restrict processing of your data</li>
            <li>Data portability</li>
            <li>Withdraw consent at any time</li>
          </ul>
          <p>To exercise any of these rights, please contact us at info@mangold.ai.</p>
        </section>

        <section className="legal-section">
          <h2>9. Cookies</h2>
          <p>
            Our website uses cookies and similar technologies to enhance your browsing experience
            and analyze site traffic. You can control cookie settings through your browser preferences.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Children's Privacy</h2>
          <p>
            Our services are not directed to individuals under the age of 18. We do not knowingly
            collect personal information from children.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any material
            changes by posting the new policy on this page with an updated "Last Updated" date.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>
            <strong>Mangold, Inc.</strong><br />
            1111b South Governors Avenue, STE 48507<br />
            Dover, DE 19904, USA<br />
            Email: <a href="mailto:info@mangold.ai">info@mangold.ai</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
